<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;

	.sclectlable {
		margin-right: 20px;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	display: flex;
	align-items: center;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		background-color: #f41127;
	}
}
</style>
<template>
	<div>
		<!-- <div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.RT_GUID" placeholder="请选择资源类型">
						<el-option v-for="item in rtlist" :key="item.RT_GUID" :label="item.RT_ResourceTitle" :value="item.RT_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<div><el-input placeholder="请输入内容资源名称" v-model="pagesobj.ResourceName" clearable></el-input></div>
			</div>

			<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div> -->
		<div class="resourbtn">
			<el-button @click="setresour" type="primary" size="small" icon="fa fa-plus">确认选择资源</el-button>
			<div style="margin: 0 10px;">
				<el-select v-model="pagesobj.RT_GUID" placeholder="请选择资源类型">
					<el-option v-for="item in rtlist" :key="item.RT_GUID" :label="item.RT_ResourceTitle" :value="item.RT_GUID"></el-option>
				</el-select>
			</div>
			<div class="sclectlable" style="margin: 0 10px;">
				<div><el-input placeholder="请输入内容资源名称" v-model="pagesobj.ResourceName" clearable></el-input></div>
			</div>

			<div style="margin: 0 10px;" class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>

		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table
							:data="tableData"
							header-row-class-name="tablestitle"
							border
							ref="childtable"
							@select="selectionchange"
							@select-all="handleSelectAll"
							style="width: 100%"
						>
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="资源名称" prop="LR_Title"></el-table-column>
							<el-table-column label="专业" prop="pro_name"></el-table-column>
							<el-table-column label="岗位" prop="PR_ProfessionalName"></el-table-column>
							<el-table-column label="封面图片">
								<template slot-scope="scope">
									<div><img :src="scope.row.LR_SurfacePlotUrl" style="width: 100px;height: 80px;" alt="" /></div>
								</template>
							</el-table-column>
							<el-table-column label="资源类型" prop="RT_ResourceTitle"></el-table-column>
							<el-table-column label="上传者" prop="ui_UserName"></el-table-column>
							<el-table-column label="上传时间" prop="LR_UploadTime"></el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { ResourceDetails, getResourceList, getGetProfList, getPositionList, getGetResourceTypes, ResourceReview, DeleteResource } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	props: {
		caguid: String,
		prguid: String,
		ilguid: String,
		list:Array
	},
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/homesview/resource/resource',
					name: '资源管理'
				}
			],
			tabsnum: 10,
			totalall: 0,
			tabindex: 1,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 5,
				pageIndex: 1,
				RT_GUID: '',
				ProfessionalID: '',
				PR_GUID: '',
				ResourceName: ''
			},
			tabsnun: 1,
			tableData: [],
			// 获取专业、岗位、资源类型列表
			prolist: [],
			polist: [],
			rtlist: [],
			choicetableData: []
		};
	},
	components: {
		titles
	},
	mounted() {
		this.pagesobj.ProfessionalID = this.caguid;
		this.pagesobj.PR_GUID = this.prguid;
		this.pagesobj.IL_GUID = this.ilguid;
		this.choicetableData = this.list
		this.get();
	},
	methods: {
		setresour() {
			// console.log("添加",this.choicetableData)
			// let recourlist = [];
			// this.choicetableData.forEach(item => {
			// 	recourlist.push({
			// 		cr_resourcetitle: item.LR_Title,
			// 		cr_OriginalFileUrl: item.LR_OriginalFileUrl,
			// 		cr_NewFileUrl: item.LR_NewFileUrl,
			// 		cr_FileName:  item.LR_FileName,
			// 		cr_FileSuffix:  item.LR_FileSuffix,
			// 		CR_Weighted: 100.0,
			// 		LR_GUID:item.LR_GUID
			// 	});
			// });

			this.$emit('custom-event', this.choicetableData);
		},
		// 选择
		selectionchange(list, row) {
			if (this.choicetableData.find(item => item.LR_GUID == row.LR_GUID)) {
				//下面这个filter方法就是删除的方法
				this.choicetableData = this.choicetableData.filter(item => item.LR_GUID != row.LR_GUID);
			} else {
				this.choicetableData.push(row);
			}

			// console.log(this.choicetableData)
		},
		// 全选
		//该方法是当页全选的方法
		handleSelectAll(rows) {
			if (rows.length) {
				rows.forEach(row => {
					if (!this.choicetableData.find(item => item.LR_GUID == row.LR_GUID)) {
						this.choicetableData.push(row);
					}
				});
			} else {
				this.tableData.forEach(row => {
					this.choicetableData = this.choicetableData.filter(item => item.LR_GUID != row.LR_GUID);
				});
			}
		},

		changetablesize() {
			this.pagesobj.pageSize = this.tabsnun;
		},
		editszy(itm) {
			// 点击编辑 获取详情
			let source = {
				LR_GUID: itm.LR_GUID
			};
			ResourceDetails(source).then(res => {
				// console.log(res);
				this.$router.push('/resources/resource/uploadresour');
				window.localStorage.setItem('resources', JSON.stringify(res.data.data));
			});
		},
		gosesours(i) {
			let size = this.formatSize(i.LR_FileSize);
			let routerurl = this.$router.resolve({
				path: '/resource/resourcedetils?liguid=' + i.LR_GUID + '&size=' + size
			});
			window.open(routerurl.href, '_blank');
		},
		formatSize(bytes) {
			let units = ['KB', 'MB', 'GB', 'TB'];

			if (bytes < 1024) {
				return bytes + ' ' + units[0];
			} else if (bytes < 1024 * 1024) {
				return (bytes / 1024).toFixed(2) + ' ' + units[1];
			} else if (bytes < 1024 * 1024 * 1024) {
				return (bytes / (1024 * 1024)).toFixed(2) + ' ' + units[2];
			} else if (bytes < 1024 * 1024 * 1024 * 1024) {
				return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' ' + units[3];
			} else {
				return (bytes / (1024 * 1024 * 1024 * 1024)).toFixed(2) + ' ' + units[4];
			}
		},
		confirmsh(re, i) {
			let review = {
				LR_GUID: re.LR_GUID,
				LR_State: i
			};

			ResourceReview(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getresours();
				}
			});
		},
		deleteresce(re) {
			let review = {
				LR_GUID: re.LR_GUID
			};
			DeleteResource(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getresours();
				}
			});
		},
		changesqx(e) {
			if (e == 0) {
				return '全网公开（所有登录用户）';
			} else if (e == 1) {
				return '只对本院校公开';
			} else if (e == 2) {
				return '全网公开（游客、非注册用户）';
			} else {
				return '私有';
			}
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(e) {
			// console.log(e, this.pagesobj.pageIndex);
			this.pagesobj.pageIndex = e;
			this.get();
		},
		get() {
			this.getresours();
		},
		getprolist() {
			getGetProfList().then(res => {
				// console.log(res.data.data)
				if (res.data.code > 0) {
					this.prolist = res.data.data;
					// console.log(this.prolist)
					if (this.pagesobj.ProfessionalID !== '') {
						this.getpolist();
					}
				}
			});
		},
		getpolist() {
			getPositionList(this.pagesobj.ProfessionalID).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		},
		getresours() {
			getResourceList(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;

					if (this.choicetableData.length > 0) {
						this.$nextTick(() => {
							this.tableData.forEach((item, index) => {
								if (this.choicetableData.findIndex(v => v.LR_GUID == item.LR_GUID) >= 0) {
									this.$refs.childtable.toggleRowSelection(item, true);
								}
							});
						});
					}
				}
			});
		}
	}
};
</script>
